import React from 'react'

const TimeDuration = ({ time, duration }) => {
  return (
    <div className="flex flex-right flex-middle">
      <div className="pl-0010 pr-0010 flex flex-column ta-r">
        <span className="fs-13 c-black-70 " style={{ paddingBottom: '2px' }}>
          {time}
        </span>
        <span className="fs-13 c-black-40">
          {(duration === '0 hour' || duration === '0 day') ? 'departure time' : duration}*
        </span>
      </div>
      <div className="pl-2 arrow-triangle__grey" />
    </div>
  )
}

export default TimeDuration
